import { AlertCircle, XClose } from "@untitledui/icons";

/**
 * "Missing Data Detected" banner for the Regulatory tables (OR-1328).
 * Slim full-width warning strip rendered above the table: warning glyph,
 * bold title, guidance copy and a dismiss X. The trigger/dismiss state
 * lives in the caller — per design it (re)appears when the user clicks
 * Save or lands on the page, and the X hides it until the next trigger.
 * Shared by Acuity today; the Survey redesign reuses it as-is.
 */
export function MissingDataBanner({ description, onClose }: { description: string; onClose: () => void }) {
    return (
        <div
            role="alert"
            className="border-secondary bg-primary flex items-center gap-3 border-b px-4 py-3 text-sm"
        >
            <AlertCircle aria-hidden="true" className="text-utility-yellow-500 size-5 shrink-0" />
            <p className="text-tertiary min-w-0 flex-1">
                <span className="text-primary font-semibold">Missing Data Detected</span> {description}
            </p>
            <button
                type="button"
                aria-label="Dismiss missing data alert"
                onClick={onClose}
                className="text-fg-quaternary hover:text-fg-secondary hover:bg-secondary_hover inline-flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-md transition duration-100 ease-linear"
            >
                <XClose className="size-4" />
            </button>
        </div>
    );
}
